module.exports = __webpack_public_path__ + "img/OpaOslo.b2b11e07.jpg";